import React, { useState } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import { Formik } from 'formik';
import { emailSubsFormValidationSchemaForInAppMessage } from '../../../../validationSchemas/contactUsSchema';
import { FormField } from '../../../FormFields/FormField';
import { Link } from 'react-router-dom';
import { getUser } from '../../../../helpers/helperMethods';
import useCheckMobileScreen from '../../../../hooks/useCheckMobileScreen';
import { CUSTOMER_MICRO_SERVICE, ROUTE_MENU } from '../../../../constants';
import { Toast_Func } from '../../../../helpers/toast.helper';
import axios from 'axios';
import { SectionDataModel } from '../../../../models/sections.model';
import Confirmation from '../../../confirmation/Confirmation';
import Spinner from '../../../Spinner/Spinner';

const Confirmation_data = {
  section_title: 'THANK YOU!',
  section_details: 'You are now on our mailing list.',
  sub_title: 'Work Up an Appetite?',
  button_class: '',
  Section_controller: 'pb-4 pb-sm-5',
  button_text: 'START AN ORDER',
  button_link: ROUTE_MENU,
};

export default function EmailSubscription(props) {
  const { inAppMessage, handleModalClose, styleClasses } = props;
  const { extras } = inAppMessage;

  const isItMobile = useCheckMobileScreen();

  const [buttonLoading, setButtonLoading] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const handleFormSubmit = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(true);
    setButtonLoading(true);
    try {
      const user = getUser();
      const payload = {
        ...extras,
        encoded_cz_id: user.encoded_cz_id,
        source: isItMobile ? 'Mobile Web' : 'Web',
        email: values.email,
      };
      await axios.post(
        `${CUSTOMER_MICRO_SERVICE}/loyalty/campaign-trigger`,
        payload
      );
      setShowConfirmationModal(true);
    } catch (error) {
      Toast_Func({
        status: false,
        message: error?.response?.data?.message,
      });
    } finally {
      setSubmitting(false);
      setButtonLoading(false);
    }
  };

  const initialFormState = {
    email: '',
  };
  return (
    <Modal
      show={inAppMessage}
      centered
      className="theme-modal-style app_container_wrap campaign-modal-header  border-radius-15 px-5 order_type_modal"
      onHide={handleModalClose}
      size="sm"
    >
      <Modal.Header className="justify-content-between p-0">
        {extras?.image_url && !buttonLoading && !showConfirmationModal && (
          <img src={extras?.image_url} className={styleClasses.topImage} />
        )}
        <button
          type="button"
          className="btn modal-close-button pe-0 blue-icon fw-bolder"
          onClick={handleModalClose}
        >
          Close
        </button>
      </Modal.Header>
      <Modal.Body
        className={`px-3 gap-40 ${extras?.image_url && !showConfirmationModal && !buttonLoading  ? 'm-2' : 'pt-5 m-2 mt-3'}`}
      >
        {showConfirmationModal ? (
          <Confirmation Confirmation_data={Confirmation_data} />
        ) : (
          <>
            <p
              className="f-s22 font-Cls text-center fw-normal mb-2 text-capitalize"
              style={{ whiteSpace: 'pre-line' }}
            >
              <span>{extras?.header}</span>
            </p>
            <div className="text_center">
              <div className="f-s14 mt-2 text-center mb-4 font-Visby-cf">
                <span style={{ whiteSpace: 'pre-line' }}>{extras?.body}</span>
              </div>
              {buttonLoading ? (
                <Spinner
                  className={styleClasses.footer_spinner}
                  lightBg={true}
                  modalSpinner={true}
                ></Spinner>
              ) : (
                <div className="new_form_design gap-40">
                  <Formik
                    onSubmit={handleFormSubmit}
                    initialValues={initialFormState}
                    validationSchema={
                      emailSubsFormValidationSchemaForInAppMessage
                    }
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleSubmit,
                      isSubmitting,
                    }) => (
                      <React.Fragment>
                        <form onSubmit={handleSubmit}>
                          <Row>
                            <Col
                              md={12}
                              xs={12}
                              className="text-start px-3 mx-0"
                            >
                              <FormField
                                name="email"
                                type={'text'}
                                value={values.email}
                                onChange={handleChange}
                                labelText="Email"
                                placeholder={extras?.input_placeholder_text ?? "Enter Your Email"}
                                errors={errors}
                                touched={touched}
                                showStaricInCaseOfRequired={true}
                                showErrorOnChange={true}
                              />
                            </Col>
                          </Row>
                          <Row className="text-center">
                            <Col>
                              <button
                                className={`${styleClasses.signup_button} btn-large dark-grey`}
                                disabled={isSubmitting || buttonLoading}
                                type="submit"
                                value={extras?.button_title}
                              >
                                {extras?.button_title}
                              </button>
                              <p
                                className={`${styleClasses.bottom_text} f-s13`}
                              >
                                By clicking ‘{extras?.button_title}’, you accept our{' '}
                                <Link
                                  to={'/privacyPolicy'}
                                  onClick={() => {
                                    handleModalClose();
                                  }}
                                >
                                  Privacy Policy
                                </Link>
                                .
                              </p>
                            </Col>
                          </Row>
                        </form>
                      </React.Fragment>
                    )}
                  </Formik>
                </div>
              )}
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}
